import { type CallhomeCamera, type DeviceEntity } from '@solinkcorp/api-types';
import React, { createContext, useContext } from 'react';

export interface PeopleTrackingResult {
  rawData: Record<string, any> | undefined;
}

export type UsePeopleTrackingCamera = (params: {
  deviceUrl: string;
  locationCameras: CallhomeCamera[] | undefined;
  locationVersion?: DeviceEntity['currentSoftwareMajorVersion'];
  maxNumberOfCamerasOverride?: number;
  tpuStatus?: DeviceEntity['tpuStatus'];
  isVisionAnalyticsEnabled?: boolean;
}) => PeopleTrackingResult;

const PeopleTrackingContext = createContext<UsePeopleTrackingCamera | null>(null);

export function usePeopleTrackingCamera(
  params: Parameters<UsePeopleTrackingCamera>[0],
): PeopleTrackingResult {
  const hook = useContext(PeopleTrackingContext);
  if (!hook) {
    throw new Error('usePeopleTrackingCamera must be used within a PeopleTrackingProvider');
  }
  return hook(params);
}

export function PeopleTrackingProvider({
  hook,
  children,
}: {
  hook: UsePeopleTrackingCamera;
  children: React.ReactNode;
}) {
  return <PeopleTrackingContext.Provider value={hook}>{children}</PeopleTrackingContext.Provider>;
}
